import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from '../ConsultDoctor.module.css'
import * as api from '../../../services/ApiConsultDoctor'
import LoaderAnimation from '../../../components/LoaderAnimation'

import { notifyError } from "../../../components/NotifyToast";

export default function BloodTestResults({ PID }) {

    const [loading, setLoading] = useState(false)
    const [dataBloodTest, setDataBloodTest] = useState([])

    useEffect(() => {
        findBloodTestResult()
    }, [])

    const findBloodTestResult = async () => {

        setLoading(true)
        let res = await api.findBloodTestResult(PID)
        setLoading(false)

        if (res)
        {
            if (res['data']['status'] === true)
            {
                const results = res['data']['data'];

                const resultsN = results.length;
                const newResults = [];
                for (let i=0; i<resultsN; i++)
                {
                    const result = results[i];
                    const tests = result.TestResults;
                    const testsN = tests.length;

                    // Map first to eliminate duplicate param/key
                    const data = {};
                    for (let j=0; j<testsN; j++)
                    {
                        const params = tests[j].TestResults;
                        const paramsN = params.length;
                        for (let k=0; k<paramsN; k++)
                        {
                            const param = params[k];
                            data[param.ResultName] = param;
                        }
                    };

                    const keys = Object.keys(data);
                    const keysN = keys.length;
                    const dataset = [];
                    for (let j=0; j<keysN; j++)
                    {
                        const key = keys[j];
                        dataset.push({
                            name: key,
                            value: data[key].ResultValue,
                            unit: data[key].ResultUnit,
                        });
                    };

                    newResults.push({
                        date: result.TestDate,
                        dataset: dataset
                    });
                };

                setDataBloodTest(newResults);
            }
            else setDataBloodTest([])
        }
        else notifyError('ไม่ตอบสนอง')
    }

    const convertDate = (dataDate) => {
        const date = new Date(dataDate)
        const optionDate = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            timeZone: 'UTC',
        }

        const thaiLocale = 'th-TH';
        const formattedDate = date.toLocaleDateString(thaiLocale, optionDate)

        const newDate = `${formattedDate}`
        return newDate
    }

    return (
        <>
            <LoaderAnimation loading={loading} />

            <Box sx={{
                textAlign: 'start',
                ml:2,
                color: '#082C91',
                fontSize: '24px',
                '@media (max-width: 512px)': { textAlign: 'center', }
            }}>
                ผลตรวจเลือด
            </Box>

            {dataBloodTest.length > 0 ?
                <Box sx={{
                    display: 'flex',
                    gridGap: 20,
                    overflow: "hidden",
                    overflowX: "scroll",
                    height: 'auto',
                    mt:2, mx: 1,
                    alignItems: 'baseline',
                    '@media (max-width: 600px)': {
                        flexDirection: 'column',
                        mx: 0,
                        width: '240px',
                        alignItems: 'center'
                    } 
                }}>
                    {dataBloodTest.map((result, i) => (
                        <Box key={i}
                            sx={{
                                backgroundColor: '#E3E9F2',
                                borderRadius: 2,
                                padding: 1,
                                minWidth: '240px',
                                '@media (max-width: 500px)': {maxWidth: '240px'}
                            }}
                        >
                            <div className={styles.date} align='center' >{convertDate(result.date)}</div>
                            <Box sx={{
                                backgroundColor: '#FFFFFF',
                                borderRadius: 2,
                                padding: 2,
                                height: 'auto',
                                alignContent:'center',
                                '@media (min-width: 500px)': {minHeight: '270px'}
                            }}>
                                { result.dataset.length > 1 ?
                                    result.dataset.map((param, j) => (
                                        <div className={styles.detail} key={j} >
                                            <div className={styles.resultName}>{param.name}</div>
                                            <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gridGap:6}}>
                                                <div className={styles.resultValue}>{param.value}</div>
                                                <div className={styles.resultUnit}>{param.unit}</div>
                                            </div>
                                        </div>
                                    ))
                                    :
                                    <div style={{justifyItems:'center'}}>
                                        <div className={styles.resultName} style={{display:'block',  fontSize:'24px'}}>{result.dataset[0].name}</div>
                                        <div className={styles.resultValue} style={{fontSize:'32px', lineHeight:'56px'}}><b>{result.dataset[0].value + " "}</b></div>
                                        <div className={styles.resultUnit} style={{fontSize:'24px'}}>{result.dataset[0].unit}</div>
                                    </div>
                                }
                            </Box>
                        </Box>
                    ))}
                </Box>
                :
                <div style={{ textAlign: 'center', margin: '20%', fontSize: 28 }}>ไม่พบข้อมูล</div>
            }
        </>
    )
}
